import React from "react";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import QnShopItem from "./QnShopItem";
import { getLogoutPlatformUrl } from "@/utils/ShopUtils";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import OrderTab from "../../enum/OrderTab";
import { observer } from "mobx-react-lite";
import { AxiosPlatformType, axiosGroupByShopType } from "@/services/http/platformServer";
import { useGlobalStore } from "@/store/hooks";
import AppVersion from "@/enum/AppVersion";
import { handleBackTop } from "@/components/BackTop";

interface ShopItemProps {
    shop: ShopDTO;

    currentShopId?: number;

    isTBUser: boolean;
}

const ShopItem: React.FC<ShopItemProps> = function (props) {
    const { shop, isTBUser, currentShopId } = props;

    const globalStore = useGlobalStore();

    const shopSetting = globalStore.shopSettingMapping.get(shop.id);

    const isSelected = shop.id === currentShopId;

    const className = isSelected ? "nav-link active" : "nav-link";

    const shopName = shop?.name;
    const shopTypeDom = <span className="text-muted small">({ShopTypeNameMap[shop.type]})</span>;

    const shopNameDom = (
        <>
            {isSelected && shopSetting?.appVersion === AppVersion.PREMIUM ? (
                <img
                    className="shop-select-advanced-icon"
                    src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01sXgC252DwkHhKuLKV_!!54458674.png"
                    alt=""
                />
            ) : null}
            {shopName}
            {shopTypeDom}
        </>
    );

    // 在千牛内，不是聚石塔和阿里云的店铺,需要跳出浏览器
    if (
        import.meta.env.VITE_IS_QN &&
        ![AxiosPlatformType.JST, AxiosPlatformType.ALIYUN].includes(axiosGroupByShopType(shop.type))
    ) {
        return (
            <QnShopItem shopId={shop.id} key={shop.id}>
                {shopNameDom}
            </QnShopItem>
        );
    }

    if (!isTBUser && (shop.type === ShopType.TAOBAO || shop.type === ShopType.TAOBAO_DISTRIBUTION)) {
        const redirectUrl = getLogoutPlatformUrl(
            shop.type,
            "https://oauth.taobao.com/authorize?client_id=12260155&response_type=code&&redirect_uri=https://tb.fahuoyi.com/platform/login/oauth/taobao",
        );

        return (
            <Tooltip title="应淘宝安全要求，需用淘系账号登录才可以查看淘宝订单，点击会跳转到淘宝登录" key={shop.id}>
                <a className={className} href={redirectUrl}>
                    {shopNameDom}
                </a>
            </Tooltip>
        );
    }

    return (
        <Link
            key={shop.id}
            className={className}
            to={{
                pathname: "/order/list",
                search: `shopId=${shop.id}&tab=${OrderTab.PENDING_SHIPMENT}`,
            }}
            onClick={() => {
                handleBackTop();
            }}
        >
            {shopNameDom}
        </Link>
    );
};

export default observer(ShopItem);
